import { Injectable } from '@angular/core';
import { Observable, map, startWith, of, debounceTime, distinctUntilChanged, switchMap, catchError, BehaviorSubject, tap } from 'rxjs';
import { ContainerType } from 'src/app/data/model/container-type';
import { PortalGroup } from 'src/app/data/model/portal-group';
import { ServiceOrder } from 'src/app/data/model/service-order';
import { TagType } from 'src/app/data/model/tag-event';
import { TaggableResource } from 'src/app/data/model/tag-resource';
import { TaggableResourceList } from 'src/app/data/model/taggable-resource-list';
import { TaggableResourcePickupRoute } from 'src/app/data/model/taggable-resource-pickup-route';
import { ContainerTypeApiService } from 'src/app/shared/api/services/container-type-api.service';
import { OdsIdApiService } from 'src/app/shared/api/services/ods-id-api.service';
import { PortalGroupApiService } from 'src/app/shared/api/services/portal-group-api.service';
import { TaggableResourceApiService } from 'src/app/shared/api/services/taggable-resource-api.service';
import { TaggableResourcePickupListApiService } from 'src/app/shared/api/services/taggable-resource-pickup-list-api.service';
import { TaggableResourcePickupRouteApiService } from 'src/app/shared/api/services/taggable-resource-pickup-route-api.service';
import { BaseEntityService } from 'src/app/shared/base/base-entity.service';

@Injectable({
  providedIn: 'root'
})
export class TaggableResourceRouteService extends BaseEntityService<TaggableResourcePickupRoute, TaggableResourcePickupRouteApiService> {
  constructor(
    apiService: TaggableResourcePickupRouteApiService,
    private containerService: ContainerTypeApiService,
    private portalGroupService: PortalGroupApiService,
    private odsIdService: OdsIdApiService,
    private listService: TaggableResourcePickupListApiService
  ) {
    super(apiService);
  }

  private groupsSubject = new BehaviorSubject<PortalGroup[] | null>(null);
  private containerSubject = new BehaviorSubject<ContainerType[] | null>(null);
  private odsIdSubject = new BehaviorSubject<ServiceOrder[] | null>(null);
  private listSubject = new BehaviorSubject<TaggableResourceList[] | null>(null);

  get type$(): Observable<ContainerType[] | null> {
    return this.containerSubject.asObservable();
  }
  get groups$() {
    return this.groupsSubject.asObservable();
  }
  get ods_id$(): Observable<ServiceOrder[] | null> {
    return this.odsIdSubject.asObservable();
  }

  get list$(): Observable<TaggableResourceList[] | null> {
    return this.listSubject.asObservable();
  }

  loadGroup() {
    this.portalGroupService
      .getAll()
      .pipe(tap((res:any) => this.groupsSubject.next(res.results)))
      .subscribe();
  }

  loadOdsId() {
    this.odsIdService
      .getAll()
      .pipe(tap((res:any) => this.odsIdSubject.next(res.results)))
      .subscribe();
  }


  loadContainerTypes() { 
    this.containerService
      .getAll()
      .pipe(tap((res:any) => this.containerSubject.next(res.results)))
      .subscribe();
  }

  loadLists() { 
    this.listService
      .getAll()
      .pipe(tap((res:any) => this.listSubject.next(res.results)))
      .subscribe();
  }
}